export enum ResourceType {
  Model = "Model",
  Artifact = "Artifact",
  File = "File",
  ConnectedContainer = "ConnectedContainer",
  ConnectedResource = "ConnectedResource",
}

// What a caller can create by posting content: the same categories minus the connected ones. A
// container's content is the list of what it holds, which the registry observes at the source
// rather than accepting from a caller, so there is nothing to post.
export type CreatableResourceType = ResourceType.Model | ResourceType.Artifact | ResourceType.File;
